<template>
    <div>
       <modal class="new-modal-default pointerenabled"  :name="modal_name"  transition="nice-modal-fade" :delay="100"  :width="750" :height="420" :pivot-y="0.5" :adaptive="true" :scrollable="true">
            <div class="v-modal-content" style="background-color: #ffffff !important;">
                <div class="v-modal-header" >
                    <div class="text-uppercase fs-20 text-white fw-500">Call Report Permissions</div>
                    <div>
                        <span class="icon icon-close mr-2 text-white pointer close-left" @click="hideManualSendModal"></span>
                    </div>
                </div>
                <div class="v-modal-body overflow-hidden">
                    <div class="v-modal-layout">
                        <div class="d-flex align-items-center justify-content-center h-100" v-if="ajaxCallinprogress">
                            <half-circle-spinner :animation-duration="1000" :size="60"  color="#00448b" style="margin: 0 auto;" />
                        </div>
                        <div v-else class="d-flex align-items-center justify-content-between flex-column  px-8">
                            <div class="d-flex align-items-center flex-column mt-2 w-100" >
                                <div class="w-100"  >
                                    <div class= "row">
                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                            <div class="block-callreport">
                                                <div class="infoHeaderHideShow">
                                                    <div class="descriptionheader">
                                                        <div class="description-text-header-left">
                                                            <h5 class="fw-500 whiteSpace">Call Report Permissions
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center my-3" >
                                                    <div class="col-lg-6 col-md-6 col-sm-12 ">
                                                        <span class="text-secondary whiteSpace fs-14 fw-600">Individual</span>
                                                        <multiselect class="diginew-multiselect-longshort greyblack no-default-icon mt-3"
                                                            :disabled="shareEmailList== 'Shared to All'"
                                                            name="email_recipients"
                                                            @search-change="searchCustomerInside"
                                                            @open="searchCustomerInside"
                                                            @close="dropdownEmailClosed"
                                                            :loading="isLoadingEmail"
                                                            v-model="add_permission.individual"
                                                            :searchable="true" :block-keys="['Tab']"
                                                            placeholder="Add Members"
                                                            :options="optionsEmailRecipients"
                                                            :multiple="true"
                                                            :close-on-select="true"
                                                            :show-labels="false"
                                                            :clear-on-select="true"
                                                            :hide-selected="true"
                                                            label="email"
                                                            track-by="email">
                                                            <template slot="tag"
                                                                slot-scope="{ option, remove }">
                                                                <span class="custom__tag">
                                                                    <span>{{ option.email }}</span>
                                                                    <span class="custom__remove"
                                                                        @click="remove(option)">
                                                                        <i class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                                    </span>
                                                                </span>
                                                            </template>
                                                            <template slot="afterList">
                                                                <div
                                                                    v-observe-visibility="reachedEndOfListCustomer" />
                                                            </template>
                                                            <template slot="noOptions">
                                                                <div
                                                                    class="text-secondary text-center fw-600">
                                                                    List is Empty</div>
                                                            </template>
                                                            <template slot="noResult">
                                                                <div
                                                                    class="text-secondary text-center fw-600">
                                                                    No Results Found</div>
                                                            </template>
                                                        </multiselect>
                                                    </div>
                                                    <div class="col-lg-6 col-md-6 col-sm-12 ">
                                                        <span class="text-secondary whiteSpace fs-14 fw-600">Team</span>
                                                        <multiselect class="diginew-multiselect-longshort greyblack no-default-icon mt-3"
                                                            :disabled="shareEmailList== 'Shared to All'"
                                                            @search-change="searchPermissionTeam"
                                                            @open="searchPermissionTeam"
                                                            @close="dropdownEmailClosed"
                                                            :loading="isLoadingPermissionTeam"
                                                            v-model="add_permission.team"
                                                            :searchable="true" :block-keys="['Tab']"
                                                            placeholder="Add Team"
                                                            :options="optionsEmailRecipientsTeam"
                                                            :multiple="true"
                                                            :close-on-select="true"
                                                            :show-labels="false"
                                                            :clear-on-select="true"
                                                            :hide-selected="true"
                                                            label="email_id"
                                                            track-by="email_id">
                                                            <template slot="tag"
                                                                slot-scope="{ option, remove }">
                                                                <span class="custom__tag">
                                                                    <span>{{ option.email_id }}</span>
                                                                    <span class="custom__remove"
                                                                        @click="remove(option)">
                                                                        <i class="icon-close iconsize-16 defaultDarkBlue"></i>
                                                                    </span>
                                                                </span>
                                                            </template>
                                                            <template slot="afterList">
                                                                <div
                                                                    v-observe-visibility="reachedEndOfPermissionTeam" />
                                                            </template>
                                                            <template slot="noOptions">
                                                                <div
                                                                    class="text-secondary text-center fw-600">
                                                                    List is Empty</div>
                                                            </template>
                                                            <template slot="noResult">
                                                                <div
                                                                    class="text-secondary text-center fw-600">
                                                                    No Results Found</div>
                                                            </template>
                                                        </multiselect>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class= "row ">
                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                            <div class="block-callreport">
                                                <div class="description-header">
                                                    <h5 class="fw-500 whiteSpace text-blue fs-14 mt-3 ml-1">Call report Shared</h5>
                                                </div>
                                                <div class="">
                                                    <div class="row mt-3">
                                                        <div class="col-lg-12 col-md-12 col-sm-12" >
                                                            <div class="mt-2">
                                                                <span class="chipmailCallReport"  v-for="(email,index) in permission_data.call_report_emails" :key="index">
                                                                {{email}}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row mt-3">
                                                    <div class="col-lg-12 col-md-12 col-sm-12" >
                                                        <span class="text-black whiteSpace fs-14 fw-400 ml-1">Individual List</span>
                                                        <div class="mt-2" v-if="permission_data.call_report_emails != ''">
                                                            <span class="chipmailCallReport" v-for="(email,index) in permission_data.call_report_emails.individual" :key="index">
                                                            {{email}}
                                                            </span>
                                                        </div>
                                                        <div class="form-group pt-0 mt-2" >
                                                             <div v-if="permission_data.permissions.individual">
                                                                <span class="chipmailCallReport mb-2" v-for="(email,index) in permission_data.permissions.individual" :key="index">
                                                                    {{email.email_id}}
                                                                    <span  @click="removePermissionIndividual(index)" class="pointer"> 
                                                                        <i class="icon icon-close fs-12"></i>
                                                                    </span>
                                                                </span>
                                                            </div>
                                                             <div v-if="add_permission.individual">
                                                                <span class="chipmailCallReport mt-2" v-for="(individual,index) in add_permission.individual" :key="index">
                                                                    {{individual.email}}
                                                                    <span  @click="removePermissionIndividualManual(index)" class="pointer"> 
                                                                        <i class="icon icon-close fs-12"></i>
                                                                    </span>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row mt-3">
                                                     <div class="col-lg-12 col-md-12 col-sm-12">
                                                        <span class="text-black whiteSpace fs-14 fw-400 ml-1">Team</span>
                                                        <div class="mt-2" v-if="permission_data.call_report_emails != ''">
                                                            <span class="chipmailCallReport" v-for="(email,index) in permission_data.call_report_emails.team" :key="index">
                                                            {{email}}
                                                            </span>
                                                        </div>
                                                        <div class="form-group pt-0 mt-2">
                                                            <div class="callreport-details-email mb-2" v-if="permission_data.permissions.team">
                                                               <span class="chipmailCallReport" v-for="(team,index) in permission_data.permissions.team" :key="index">{{team.email_id}}
                                                                    <span  @click="removePermissionTeam(index)" class="pointer"> 
                                                                        <i class="icon icon-close fs-12"></i>
                                                                    </span>
                                                               </span>
                                                            </div>
                                                            <div class="callreport-details-email mb-2" v-else>
                                                               <span class="chipmailCallReport">{{"-"}}</span>
                                                            </div>
                                                            <div  class="callreport-details-email mt-2" v-if="add_permission.team">
                                                               <span class="chipmailCallReport" v-for="(team,index) in add_permission.team" :key="index">{{team.email_id}}
                                                                    <span  @click="removePermissionTeamManual(index)" class="pointer"> 
                                                                        <i class="icon icon-close fs-12"></i>
                                                                    </span>
                                                               </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class= "row mt-2">
                                        <div class="col-lg-12 col-md-12 col-sm-12">
                                            <div class="block-callreport">
                                                <div class="d-flex">
                                                    <div class="description-header">
                                                        <h5 class="fw-500 whiteSpace text-blue fs-14 mt-3 ml-1">Access To</h5>
                                                    </div>
                                                    <div class="col-lg-3 col-md-3 col-sm-6">
                                                        <div class="pointer d-flex">
                                                            <multiselect class="diginew-multiselect multiselect_border new-align-multi no-default-icon down-arrow mt-2"
                                                                name="shareEmailList"
                                                                v-model="shareEmailList"
                                                                :options="optionsShareList"
                                                                @select="showPermissionFields"
                                                                :multiple="false"
                                                                :close-on-select="true"
                                                                :show-labels="false"
                                                                :clear-on-select="true"
                                                                :hide-selected="true">
                                                                <template slot="noOptions">
                                                                    <div class="text-secondary text-center fw-600"> List is Empty</div>
                                                                </template>
                                                                <template slot="noResult">
                                                                    <div class="text-secondary text-center fw-600">  No Results Found</div>
                                                                </template>
                                                            </multiselect>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="disableButtonAndDisplayLoader == false" class="d-flex flex-wrap align-items-center justify-content-center mb-5 mt-2">
                        <button class="btn new-cancel-button mt-2" @click="hideManualSendModal">Cancel</button>
                        <button class="btn new-save-button mt-2 ml-6" @click="saveManualSendModal" >Save</button>
                    </div>
                    <div v-else class="d-flex flex-wrap align-items-center justify-content-center mb-5 mt-2">
                        <button class="btn new-cancel-button mt-2" disabled style="border: 1px solid transparent !important;">Cancel</button>
                        <button class="btn new-save-button mt-2 ml-6" disabled style="position: relative; border: 1px solid transparent">Save
                            <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                        </button>
                    </div>
                </div>
            </div>
            <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
            <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        </modal>
    </div>
</template>

<script>
import callreport from './mixins/callreport';
import teams from './mixins/teams';
import {
        SweetModal
    } from 'sweet-modal-vue';
import leads from "./mixins/leads";
 import { EventBus } from "./eventBus/nav-bar-event.js";
 import {
        HalfCircleSpinner
    } from "epic-spinners";
import { HollowDotsSpinner } from "epic-spinners";
export default {
    data() {
        return {
            disableButtonAndDisplayLoader: false,
            total: 0,
            skip: 0,
            skip_count: 0,
            limit: 10,
            search_term: "",
            search_key: "",
            isLoading: false,
            isVisible: false,
            view_data:[],
            permission_data:{
                individual:[{
                    email: "",
                    id: '',
                    name:''
                }],
                team:[{
                    email: "",
                    id: '',
                    name:''
                }]
            },
            call_report_email:{
                individual:[],
                team:[]
            },
            add_permission:{
                individual:[],
                team:[]
            },
            email_regex: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,50})+$/,
            invalidEmail: false,
            noEmail: false,
            optionsEmailRecipients: [],
            optionsEmailRecipientsTeam:[],
            optionsShareList:['Shared to All' , 'Individual and Team'],
            shareEmailList:'Individual and Team',
            ajaxCallinprogress:false,
            isLoadingPermissionTeam:false,
            isLoadingEmail:false,
            warning_msg:'',
            success_msg:'',
            user_ids_ind:[],
            user_ids_team:[],
        }
    },
    mixins:[callreport,leads,teams],
    props: ["modal_name","data_id"],
    components:{
        HalfCircleSpinner,
        SweetModal,
        HollowDotsSpinner,
    },
    methods: {
        //show the permission fields
        /**@params = type */
        showPermissionFields(type){
            if(type == 'Shared to All'){
                this.add_permission.individual = ""
                this.add_permission.team = ""
            }
        },
        //remove the permission individual data from dropdown
        /**@params = index */
        removePermissionIndividual(index){
            this.permission_data.permissions.individual.splice(index,1)
        },
        //remove the permission individual manually 
        /**@params = index */
        removePermissionIndividualManual(index){
            this.add_permission.individual.splice(index,1)
        },
        //remove the permission team data form dropdown 
        /**@params = index */
        removePermissionTeam(index){
            this.permission_data.permissions.team.splice(index,1)
        },
        //remove the permission team  manually
        /**@params = index */
        removePermissionTeamManual(index){
            this.add_permission.team.splice(index,1)
        },
        //dropdown email closed method to clear the search key
        dropdownEmailClosed(){
            this.search_term ="";
            this.skip = 0;
        },
        //hide the manual send modal
        hideManualSendModal() {
            this.$emit('hideSendModal')
        },
        //save/updated the manual send modal
        /**@params = mode */
        async saveManualSendModal(mode) {
            this.disableButtonAndDisplayLoader = true;
            try{
                let permission_ind_data =[]
                let permissionsEmailIndividual = []
                if (this.permission_data.permissions.individual && this.permission_data.permissions.individual.length) {
                    permissionsEmailIndividual = JSON.parse(JSON.stringify(this.permission_data.permissions.individual))
                    permissionsEmailIndividual.forEach((x, index) => {
                        permission_ind_data.push({
                            email_id : x.email_id,
                            id :x.id || x.user_id,
                            name: x.full_name || x.name
                        })
                    })
                }
                let permissionsEmailIndividualManual = []
                if (this.add_permission.individual && this.add_permission.individual.length) {
                    permissionsEmailIndividualManual = JSON.parse(JSON.stringify(this.add_permission.individual))
                    permissionsEmailIndividualManual.forEach((x, index) => {
                        permission_ind_data.push({
                            email_id : x.email,
                            id :x.user_id || x.id,
                            name: x.full_name || x.name
                        })
                    })

                }
                let permission_team_data =[]
                let permissionsEmailTeamManual = []
                if (this.add_permission.team && this.add_permission.team.length) {
                    permissionsEmailTeamManual = JSON.parse(JSON.stringify(this.add_permission.team))
                    permissionsEmailTeamManual.forEach((x, index) => {
                        permission_team_data.push({
                            email_id : x.email_id,
                            id :x.id,
                            name: x.full_name || x.name
                        })
                    })
                }
                let permissionsEmailTeam = []
                if (this.permission_data.permissions && this.permission_data.permissions.length) {
                    permissionsEmailTeam = JSON.parse(JSON.stringify(this.permission_data.permissions.team))
                    permissionsEmailTeam.forEach((x, index) => {
                        permission_team_data.push({
                            email_id : x.email_id,
                            id :x.id,
                            name: x.full_name || x.name
                        })
                    })
                }
                let params = {
                    id :this.data_id,
                    general_access : this.shareEmailList == 'Shared to All' ? 'public' : 'private',
                    permissions: {
                        individual : permission_ind_data,
                        team : permission_team_data
                    }
                }
                let response = await this.savePermissionData(params)
                if(response.status_id == 1){
                    this.success_msg = response.message
                    this.$refs.success_modal.open();
                    setTimeout(() => {
                        this.disableButtonAndDisplayLoader = false;
                        this.$refs.success_modal.close();
                        this.hideManualSendModal()
                    },2000);
                }
                else {
                    this.warning_msg = response.reason
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.disableButtonAndDisplayLoader = false;
                        this.$refs.warning_modal.close();
                    }, 1000);
                }
            }
            catch(error){
                // console.log(error)
                this.disableButtonAndDisplayLoader = false;
            }
        },
        //API call to search permission indvidual
        /**@parmas = key , @params =value */
        async searchCustomerInside(key,value) {
            this.isLoadingEmail = true
            if (key) {
                this.search_term = key ;
            }
            /**@parmas = skip , @params = limit  , @params = search_key, @parmas = exclude*/
            let params = {
                skip: this.skip,
                limit: this.limit,
                search_key: this.search_term,
                exclude: this.user_ids_ind
            };
            let res = await this.getMembersData(params);
            this.optionsEmailRecipients = res.response;
            this.optionsEmailRecipients = this.optionsEmailRecipients.filter((thing, index) => {
                const payload = JSON.stringify(thing);
                return index === this.optionsEmailRecipients.findIndex(obj => {
                    return JSON.stringify(obj) === payload;
                });
            });
            this.email_skip_count = res.response.length
            this.count = 0;
            this.isLoadingEmail = false;
        },
        //API call to lazy loading of the list of customer
        /**@parmas = reached */
        async reachedEndOfListCustomer(reached) {
            this.isVisible = reached;
            if (reached) {
                if (this.scrollableCustomer == false) {
                    this.isLoadingEmail = true;
                    /**@parmas = skip , @params = limit  , @params = search_key, @parmas = exclude*/
                    let res = await this.getMembersData({
                        skip: this.skip,
                        limit: this.limit,
                        search_key: this.search_term,
                        exclude: this.user_ids_ind
                    });
                    if (res.response.length > 0) {
                        let tempFiles = res.response;
                        tempFiles.forEach(el => {
                            this.optionsEmailRecipients.push(
                                el);
                        });
                        this.optionsEmailRecipients = this.optionsEmailRecipients.filter((thing, index) => {
                            const payload = JSON.stringify(thing);
                            return index === this.optionsEmailRecipients.findIndex(obj => {
                                return JSON.stringify(obj) === payload;
                            });
                        });
                        this.count += res.response.length;
                        this.isLoadingEmail = false;
                    } else {
                        this.scrollableCustomer = true;
                        this.isLoadingEmail = false;
                    }
                    this.isLoadingEmail = false;
                }
            }
        },
        //API call to search permission team
        /**@parmas = key */
        async searchPermissionTeam(key) {
            this.isLoadingPermissionTeam = true;
            if (key) {
                this.search_term = key ;
            }
            /**@parmas = skip , @params = limit  , @params = search_key, @parmas = filter_json*/
            let params = {
                skip: this.skip,
                limit: this.limit,
                search_key: this.search_term,
                filter_json:{
                    exclude: this.user_ids_team
                }
            };
            let res = await this.getPermissionList(params);
            this.optionsEmailRecipientsTeam = res.response;
            this.optionsEmailRecipientsTeam = this.optionsEmailRecipientsTeam.filter((thing, index) => {
                const payload = JSON.stringify(thing);
                return index === this.optionsEmailRecipientsTeam.findIndex(obj => {
                    return JSON.stringify(obj) === payload;
                });
            });
            this.email_skip_count = res.response.length
            this.count = 0;
            this.isLoadingPermissionTeam = false;
        },
        //API call of lazy loading permission team
        /**@parmas = reached */
        async reachedEndOfPermissionTeam(reached) {
            this.isVisible = reached;
            if (reached) {
                if (this.scrollableCustomer == false) {
                    this.isLoadingPermissionTeam = true;
                    /**@parmas = skip , @params = limit  , @params = search_key, @parmas = filter_json*/
                    let res = await this.getPermissionList({
                        skip: this.email_skip_count,
                        limit: 10,
                        search_key: '',
                        filter_json:{
                            exclude: this.user_ids_team
                        }
                    });
                    if (res.response.length > 0) {
                        let tempFiles = res.response;
                        tempFiles.forEach(el => {
                            this.optionsEmailRecipientsTeam.push(el);
                        });
                        this.optionsEmailRecipientsTeam = this.optionsEmailRecipientsTeam.filter((thing, index) => {
                            const payload = JSON.stringify(thing);
                            return index === this.optionsEmailRecipientsTeam.findIndex(obj => {
                                return JSON.stringify(obj) === payload;
                            });
                        });
                        this.count += res.response.length;
                        this.isLoadingPermissionTeam = false;
                    } else {
                        this.scrollableCustomer = true;
                        this.isLoadingPermissionTeam = false;
                    }
                    this.isLoadingPermissionTeam = false;
                }
            }
        },
        //get the permission for individual & team
        getPermission(){
            if (this.permission_data.permissions.length < 1) {
                this.permission_data.permissions = [{
                    individual:[],
                    team:[]
                }]
            } else{
                if(this.permission_data.permissions.hasOwnProperty('individual')){
                    this.permission_data.permissions.individual.forEach((element, item_index) => {
                        this.permission_data.permissions.individual[item_index] = {
                            email: element.email_id,
                            id:element.id,
                            name:element.name
                        };
                    });
                }
                if(this.permission_data.permissions.hasOwnProperty('team')){
                    this.permission_data.permissions.team.forEach((element, item_index) => {
                        this.permission_data.permissions.team[item_index] = {
                            email: element.email_id,
                            id:element.id,
                            name:element.name
                        };
                    });
                }
            }
        },
        //API call to view the permission 
        /**@parmas = id */
        async viewPermission(id){
            this.ajaxCallinprogress = true
            try{
                let response = await this.getPermissionData(id)
                this.permission_data = response.response
                this.user_ids_ind = this.permission_data.permissions.individual.map(x => {return x.id})
                this.user_ids_team = this.permission_data.permissions.team.map(x => {return x.id})
                let access = this.permission_data.general_access
                if(access == 'private'){
                    this.shareEmailList = 'Individual and Team'
                } else {
                    this.shareEmailList = 'Shared to All'
                }
                this.ajaxCallinprogress = false
            }
            catch(error){
                // console.log(error)
                this.ajaxCallinprogress = false
            }
        },
    },
    computed: {
        loggedInUser() {
            return this.$store.state.loggedInUser;
        },
    },
    mounted(){
        this.viewPermission(this.data_id)
    }
}
</script>
<style scoped>
    .inputFieldNew{
        height :47px!important;
    }
    .infoHeaderHideShow {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -webkit-flex-direction: column;
        -ms-flex-direction: column;
        flex-direction: column;
        min-height: 40px;
        position: relative;
        -webkit-box-shadow: none;
        box-shadow: none;
        border-radius: 5px;
        line-height: 40px;
        cursor: pointer;
    }
    .infoHeaderHideShow>.descriptionheader {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        padding: 4px 10px;
        background-color: #005dae;
        border-radius: 2px;
        /* border-bottom: 1px solid transparent; */
    }
    .infoHeaderHideShow>.descriptionheader .description-text-header-left h5 {
        font-size: 16px;
        font-weight: bold;
        margin: 0;
        color: #ffffff !important;
    }
    .infoHeaderHideShow>.descriptionheader .description-text-header-right {
        font-size: 13px;
        margin-left: auto;
        padding-left: 12px;
        color: #005dae;
        font-weight: 500;
    }
    .infoHeaderHideShow>.descriptionheader .description-text-header-right {
        width: 100%;
        margin-left: 10px;
    }
    .infoHeaderHideShow>.descriptionheader .description-text-header-right i {
        color: #005dae;
        font-size: 24px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        cursor: pointer;
    }

    .infoHeaderHideShow>.descriptionheader .description-text-header-right img {
        float: right;
        color: #005dae;
        width: 28px;
        cursor: pointer;
        position: absolute;
        right: 0px;
        bottom: -15px;
    }
    .infoHeaderHideShow>.descriptionheader .description-text-header-left h5 {
        font-size: 16px;
        font-weight: bold;
        margin: 0;
        color: #ffffff;
    }
    .infoHeaderHideShow>.descriptionheader .description-text-header-right-small {
        font-size: 13px;
        margin-left: auto;
        padding-left: 12px;
        color: #005dae;
        font-weight: 500;
    }
    .infoHeaderHideShow>.descriptionheader .description-text-header-right-small {
        display: block;
        border-bottom: 1px solid #b2b2b3;
        width: 100%;
        margin-left: 10px;
    }
    .infoHeaderHideShow>.descriptionheader .description-text-header-right-small i {
        color: #005dae;
        font-size: 16px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        cursor: pointer;
    }
    .infoHeaderHideShow>.descriptionheader .description-text-header-right-small img {
        float: right;
        color: #005dae;
        width: 28px;
        cursor: pointer;
        position: absolute;
        right: 3px;
        bottom: -15px;
    }
    .block-callreport {
        padding: 15px 15px 15px 15px !important;
    }
    .review-borders {
        margin: 8.5px 0 0;
        padding: 6px;
        border-radius: 5px;
        border: solid 0.5px #3f3f3f !important;
        background-color: #ffffff;
        min-height: 33px;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .callreport-details-email {
        border-bottom: 1px solid #FFF;
    }
    .iconsize-16{
        line-height:22px !important;
    }
    
</style>


// WEBPACK FOOTER //
// src/components/ManualSendModal.vue